module.exports = __webpack_public_path__ + "img/Transactions.4372b80f.svg";